import { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import { Text } from 'components';

import styles from './AccordionPanel.module.scss';

type AccordionPanelProps = {
  label: string;
  content: string;
  activeTab: number;
  index: number;
  activateTab(): void;
};

const AccordionPanel = ({ label, content, activeTab, index, activateTab }: AccordionPanelProps) => {
  const [height, setHeight] = useState(0);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const elementHeight = innerRef.current?.scrollHeight;

    if (elementHeight) {
      setHeight(elementHeight);
    }
  }, []);

  const isActive = activeTab === index;
  const innerStyle = {
    height: `${isActive ? height : 0}px`
  };

  return (
    <div className={cx(styles.panel, { [styles.active]: isActive })} role="tabpanel">
      <button className={styles.label} role="tab" onClick={activateTab} type="button">
        <Text size="h3">{label}</Text>
      </button>
      <div ref={innerRef} className={styles.inner} style={innerStyle}>
        <p className={styles.content}>{content}</p>
      </div>
    </div>
  );
};

export default AccordionPanel;
